<template>
  <div class="container">
    <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item class="bread" :to="{ path: '/manage/equipment/equipment-list' }">设备管理</el-breadcrumb-item>
          <el-breadcrumb-item >使用单位设备详情</el-breadcrumb-item>
          <el-breadcrumb-item >使用数据</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="content">
        <div class="header-common">
          <div class="header-common-left">
            <div class="title">使用数据</div>
          </div>
          <header class="header-common-right">
            <el-button
              class="right-button-export"
              @click="exportTable"
              type="text"
              >
              导出
            </el-button>
          </header>
        </div>
        <div class="message">
          <el-descriptions title="" :column="3" border ref="inner" :contentStyle="contentStyle" :labelStyle='labelStyle'>
            <el-descriptions-item label="用户ID" id=''><span class="detail">{{patient.pid}}</span></el-descriptions-item>
            <el-descriptions-item label="年龄" id=''><span class="detail">{{patient.age}}</span></el-descriptions-item>
            <el-descriptions-item label="消融针数量" id=''><span class="detail">{{patient.consumableQuantity}}</span></el-descriptions-item>
            <el-descriptions-item label="部位" id=''><span class="detail">{{patient.part}}</span></el-descriptions-item>
            <el-descriptions-item label="性别" id=''><span class="detail">{{patient.gender}}</span></el-descriptions-item>
            <el-descriptions-item label="手术时长" id=''>
              <span class="detail">{{patient.durationText}}</span>
              </el-descriptions-item>
          </el-descriptions>
        </div>

        <div class="table">
          <el-table
          v-loading='loading'
            :data="consumablesTableData"
            border
            style="width: 100%"
            :cell-style="tableCellStyle"
            :header-cell-style="tableHeaderCellStyle"
            >
            <el-table-column
              type="index"
              label="序号">
            </el-table-column>
            <el-table-column
              prop="useTime"
              label="使用时间">
            </el-table-column>
            <el-table-column
              prop="typeName"
              label="产品名称">
            </el-table-column>
            <el-table-column
              prop="typeModel"
              label="规格型号">
            </el-table-column>
            <el-table-column
              prop="udi"
              label="耗材识别码">
            </el-table-column>
          </el-table>
        </div>

        <div class="chart">
          <!-- <div id="aaaa" style="width: 100%;height: 400px;" ref="aaaa"> -->
          </div>
        </div>

    </div>


  </div>
</template>

<script>
  // import * as echarts from 'echarts';
  import {dataConversionUtil} from '../../../utils/excel.js'

  export default {
  data() {
    return {
      contentStyle:{
        'border':'1px solid #1A3F81',
      },
      labelStyle:{
        'width': '108px',
        'font-size': '14px',
        'font-weight': 'bold',
        'color': '#00FFFF',
        'background-color':'transparent',
        'border':'1px solid #1A3F81'
      },
        patient:{
          pid:'',
          gender:'',
          age:'',
          part:'',
          consumableQuantity:'',
          duration:'',
          durationText:''
        },
        startTime:'',//使用时间
        consumablesTableData:[],
        loading:false,

        timeSeries:[],
        timeList:[],//横坐标
        tempList:[],//曲线数据
        source:[],
        data:[],
        series:[],
        myChart:null,

        // timers:null,
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    tableCellStyle() {
      return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;'
    },
    tableHeaderCellStyle() {
      return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:center;font-size: 15px;font-weight: 400;color: #00FFFF;'
    },
    getSurgeryDetail(){
      this.loading = true;
      const headers = {
          'Authorization': localStorage.getItem('token')
      }
      const url = '/equipment/surgery-detail';
      const data = {"eid":this.id,"sId":this.sid}

      this.$http({
        method:'GET',
        url:url,
        headers:headers,
        params:data
      }).then(res=>{
        this.loading = false;
        if(res.status == 200){//请求成功
        var obj = res.data;
          if(obj.code == 0){
            this.startTime = obj.data.startTime;
            //基本信息
            this.patient.pid = obj.data.patient.pid
            if (obj.data.patient.gender==1) {
              this.patient.gender = '男'
            } else{
              this.patient.gender = '女'
            }
            this.patient.age = obj.data.patient.age
            this.patient.part = obj.data.patient.part
            this.patient.duration = obj.data.duration;
            this.patient.consumableQuantity = obj.data.consumableQuantity

            // 时长
            var second = obj.data.duration;
            var durationText = this.handleNumber(parseInt(second/3600)) + ':' + this.handleNumber(parseInt((second%3600)/60)) +  ':' + this.handleNumber(parseInt((second%3600)%60));
            this.patient.durationText = durationText;

            // 耗材列表
            if(obj.data.consumables){
              this.consumablesTableData = obj.data.consumables
            }

            //温度曲线
            if(obj.data.timeList){
              this.timeList = obj.data.timeList
            }
            if(obj.data.tempList){
              this.tempList = obj.data.tempList
            }

            // this.handleChartData()
          }else{
            this.$message.error(obj.message)
          }
        }else{
          this.$message.error(res.data.message);
        }

      }).catch(err=>{
        this.loading = false;
        if(!err.response){
          this.$message.error(err.message);
        }else{
          this.$message.error(err.response.data.message);
        }
      })
    },
    handleNumber(number){
    	if(number < 10){
    		return '0' + number;
    	}
    	return number
    },
    handleChartData(){
      var list1 = this.timeList;
      var xArr = ['时间']
      for(var i=0;i<list1.length;i++){
        var aa = list1[i].split(' ')
        xArr.push(aa[1]);
      }

      var yArr = []
      yArr.push(xArr)
      var list2 = this.tempList;
      for(var j=0;j<list2.length;j++){
        var obj = list2[j];
        var tempArr = []
        tempArr.push(obj.name);
        for(var k=0;k<obj.data.length;k++){
          tempArr.push(obj.data[k])
        }
        yArr.push(tempArr);
      }

      // source
      this.source = yArr;

      var mArr = []
      var oooo = {
        // data:this.data,
        type: 'line',
        smooth: true,
        showSymbol:true,
        seriesLayoutBy: 'row',
        emphasis: { focus: 'series' },
        itemStyle: {
          normal: {
            lineStyle: {
              width: 5,
              // color:'#00FFB4'
            }
          }
        }
      }

      for(var m=0;m<list2.length;m++){
        mArr.push(oooo)
      }
      this.series = mArr;
      // this.drawLines(this.source,this.series);

      this.myChart.setOption({
        dataset: {
          source:this.source
        },
        series:this.series
      })
    },
    exportTable(){
      var tableHeader = [['使用时间','患者ID','年龄','性别','部位','手术时长','消融针数量','耗材列表']];

        var array = [];
        array.push(this.startTime)
        array.push(this.patient.pid)
        array.push(this.patient.age)
        array.push(this.patient.gender)
        array.push(this.patient.part)
        array.push(this.patient.durationText)
        array.push(this.patient.consumableQuantity)
        for(var i=0;i<this.consumablesTableData.length;i++){
          var element = this.consumablesTableData[i];
          var text = '使用时间:'+element.useTime + ';' + '类型:'+element.type + ';'+'UDI:'+element.udi;
          array.push(text);
        }
        var dataList = [array];
        
      if(dataList.length > 0){
        dataConversionUtil.dataToExcel('使用数据',tableHeader,dataList)
        this.$message.success('导出成功')
      }else{
        this.$message.warning('无数据导出')
      }
      
    },
    exportTemperatureTable(){
      var array = this.source;
      if(array.length<=0){
        this.$message('数据为空,不支持导出')
        return;
      }
      // 标题
      var array1 = []
      for(var index = 0;index<array.length;index++){
        array1.push(array[index][0])
      }
      var tableHeader = [array1];

      // 列表
      var dataList = [];
      for(var index2=0;index2<array[0].length;index2++){
        var itemArray = []
        for(var index3=0;index3<array.length;index3++){
          itemArray.push([
            array[index3][index2+1],
          ])
        }
        dataList.push(itemArray)
      }

      if(dataList.length > 0){
        dataConversionUtil.dataToExcel('温度列表',tableHeader,dataList)
        this.$message.success('导出成功')
      }else{
        this.$message.warning('无数据导出')
      }

    },

    // 温度曲线
    drawLines(){

      var chartDom = this.$refs.aaaa;
      this.myChart = echarts.getInstanceByDom(chartDom);
      if(this.myChart === undefined){
        this.myChart = echarts.init(chartDom);
      }else{
        this.myChart.dispose();
        this.myChart = null;
        this.myChart = echarts.init(chartDom);
      }

      var option = {
          legend: {
            textStyle:{
              fontSize: 15,
              color:'#fff'
            },
            type:'scroll',
            icon:'circle',
          },
          toolbox:{
            feature:{
              saveAsImage:{},
              restore:{},
              dataView:{
                show:true,
                // lang:['数据视图','关闭','导出'],

              },
              // magicType:{type:['bar','stack']},
              myTools2:{
                show:true,
                title:'导出',
                // icon:'image://https://echarts.apache.org/zh/images/favicon.png',
                icon:'path://M942.1 89c-4.6-4.8-11-7.6-17.6-7.7l-269.9-4.6c-13.8-0.2-25.2 10.8-25.4 24.6-0.2 13.8 10.8 25.2 24.6 25.4l201.8 3.4C787.3 191.9 727 257.7 675.7 326.3c-50.9 68.1-93 139-125.2 211-55.4 123.6-62.4 207-62.7 210.5-1.1 13.8 9.2 25.8 23 26.9 0.7 0.1 1.3 0.1 2 0.1 12.9 0 23.9-9.9 24.9-23 0.1-0.8 6.6-78.2 58.5-194 45-100.4 133.3-248.1 301.6-398.2l-5.4 217.2c-0.3 13.8 10.6 25.3 24.4 25.6h0.6c13.5 0 24.6-10.8 25-24.4l6.7-270.9c0.1-6.8-2.4-13.3-7-18.1z',
                // icon:'image://../../../assets/image/close.png',
                onclick:function(opt){
                  this.exportTemperatureTable()
                }
              }
            },
            iconStyle:{
              // borderCap:'square'
            }
          },
          tooltip: {
            show:true,
            trigger: 'axis',
            axisPointer: {
            }
          },
          dataset: {
            source:[]
            // source:val
          },
          xAxis: {
            name: '时间',
            type: 'category',
            axisLine:{
              show:false,
              lineStyle:{
                // color: 'rgba(0, 255, 255, 0.22)', //坐标轴颜色
              }
            },
            axisLabel: {
              color: '#fff',
              // 'rgba(0, 255, 255, 0.22)' //坐标轴的文本颜色
              formatter: '{value}'
            },
          },
          yAxis: {
            gridIndex: 0,
            // name:'温度(°C)',
            type:'value',
            axisLine:{
              show:false,
              lineStyle:{
                color: 'rgba(0, 255, 255, 0.22)',//坐标轴颜色
                // 'rgba(210, 0, 0, 1)',
                //
                // '#A5D5FF'
              }
            },
            axisLabel: {
              color: '#fff',
              // 'rgba(0, 255, 255, 0.22)' //坐标轴的文本颜色
              formatter: '{value} °C'
            }
          },
          series:[]
        };

        // that.myChart.setOption(option);
      // });

      option && this.myChart.setOption(option);

      window.addEventListener('resize',this.sizeFunOfmyChart)
    },

    sizeFunOfmyChart(){
      if(this.myChart){
        this.myChart.resize()
      }
    },
  },
  mounted() {
    this.getSurgeryDetail()
    // this.drawLines();
  },
  beforeDestroy() {

    if (this.myChart) {
      this.myChart.dispose()
      this.mychart = null;
    }

    window.removeEventListener('resize',this.sizeFunOfmyChart)
  },
  created() {
    this.id = this.$route.query.id;
    this.sid = this.$route.query.sid;
  },
  // watch:{
  //   series(val,oldVal){
  //     this.drawLines(this.source,this.series)
  //   }
  // },
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  margin-top: $header-height;

  .bread >>>.el-breadcrumb__inner{
    color: #606266;
    font-weight: 400;
  }

  .content {

    height: 840px;

    .header-common{
      /* width: 100%; */
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin: 4px 6px 0 6px;

      .header-common-left{

        font-size: 20px;

        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;

        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }

      .header-common-right{
        .right-button-export{
          font-size: 14px;
          font-weight: 400;
          color: #00FFB4;
          margin-right: 20px;
        }
      }
    }


    .message{
      margin: 0px 4px 0 6px;
    }

    .table{
      margin: 20px 4px 0 6px;
      // position: fixed;
      // top: $header-height+255px;
      // right: 20px;
      // left: 230px;
    }

    .chart{
      margin-top: 20px;
      padding: 10px;

      // position: fixed;
      // top: $header-height+400px;
      // right: 20px;
      // left: 230px;
      // bottom: $main-padding;
    }

    .detail{
      font-size: 14px;
      font-weight: 400;
      // height: 50px;
      // line-height: 50px;
      border-radius: 25px;
      /* color: #33455E; */
      /* background-color: #E9EBEE; */
      color: #fff;
      padding: 3px 25px;
    }

  }



}
</style>



// WEBPACK FOOTER //
// src/view/manage/equipment/equipment-using-record-one.vue